'use strict';


export const search = async ({ dispatch, commit, getters }) => {
	const q = getters.query;
	if (!q) { return }
	
	const results = await dispatch('find', { query: { q }});
	commit('setResults', results);
};
